import { gql } from "@apollo/client";

export const DeleteSquarePhotosSection = gql`
mutation DeleteSquarePhotosSection($deleteSquarePhotosSectionId: ID!) {
  deleteSquarePhotosSection(id: $deleteSquarePhotosSectionId) {
    status
  }
}
`;
